/* eslint-disable @typescript-eslint/no-unsafe-call */
import { loadStatechart } from './state';
let _isInitialized = false;
let _appSwitcherControls;
export const appSwitcher = async (options) => {
    if (_isInitialized) {
        return Promise.resolve(_appSwitcherControls);
    }
    const statechart = loadStatechart();
    _appSwitcherControls = {
        toggleMenu: () => {
            statechart.sendEvent('toggleMenu');
        }
    };
    _isInitialized = true;
    try {
        statechart.initStates({ default: '#init', 'data-states': '#signin.ready' });
        statechart.sendEvent('setInitialConfiguration', options);
    }
    catch (e) {
        return Promise.reject(e);
    }
    return Promise.resolve(_appSwitcherControls);
};
